import { render, staticRenderFns } from "./ContributorCreateForm.vue?vue&type=template&id=1947e554&scoped=true&"
import script from "./ContributorCreateForm.vue?vue&type=script&lang=js&"
export * from "./ContributorCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947e554",
  null
  
)

export default component.exports